export default __webpack_public_path__ + "static/media/anniversary6.3023cb03.webp";